import { useNavigate } from 'react-router-dom';
import { COLORS } from '../../../func/components/Color';
import { ReportFormatNumber } from '../../../func/Function';
import styled from 'styled-components';
import Tags from '../../../func/Tags';
import { useModal } from '../../../context/ModalContext';
import { Imminent } from './types';
import { isLogin } from '../../../utils/auth';
import { useState } from 'react';
import InterestSerivce from '../../../service/Interest';
import AddInterestItemModal from '../../components/modal/AddInterestItem';

interface Props {
  item: Imminent;
}

const ImminentItem = ({ item }: Props) => {
  const [isLikeItem, setIsLikeItem] = useState(item.isLike);
  const [showLikeModal, setShowLikeModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [activeItem, setActiveItem] = useState<number | null>(null);
  const { modalDispatch } = useModal();

  const formatSaleDate = (saledate: string) => {
    if (item.type === 'p') {
      return saledate.replace('10:00', '').replace('17:00', '');
    }
    return saledate;
  };

  const disLike = async (iidx: number) => {
    try {
      const res = await InterestSerivce.dislike(iidx);
      alert('관심물건에서 삭제되었습니다.');
      setIsLikeItem(false);
    } catch (error) {
      console.error('dislike 함수에서 에러 발생:', error);
    }
  };

  const handleDisLikeItem = (iidx: number) => {
    if (window.confirm('관심물건에서 삭제하시겠습니까?')) {
      disLike(iidx);
    }
  };

  return (
    <SlideCard
      onClick={async () => {
        if (isLogin()) {
          localStorage.setItem(
            'tab',
            item.type === 'a' ? 'auction' : 'pauction',
          );
          window.open(
            `${item.type === 'a' ? '/auction' : '/pauction'}/detail/${item.iidx}`,
            '_blank',
          );
        } else {
          modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
        }
      }}
    >
      <ImgContainer>
        <ImgTopTagSection>
          <TypeTag>{item.type === 'a' ? '경매' : '공매'}</TypeTag>
        </ImgTopTagSection>
        <LikeIcon
          onClick={(e) => {
            e.stopPropagation();
            if (!isLogin()) {
              modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
              return;
            }

            if (!isLikeItem) {
              setShowLikeModal(true);
            } else {
              handleDisLikeItem(item.iidx);
            }
          }}
        >
          <img
            src={`/assets/images/icon/${isLikeItem ? 'like-on' : 'like-off-filled'}.svg`}
            alt=""
          />
        </LikeIcon>
        <img src={item.img} alt="" />
        <ImgInfoBox>
          <span>
            {item.type === 'a' ? '매각기일' : '입찰기간'}{' '}
            {formatSaleDate(item.saledate)}
          </span>
          <ImgInfoDivider />
        </ImgInfoBox>
      </ImgContainer>

      <InfoContainer>
        <Title>
          <span>{item.itemCategory}</span>
          {item.caseno}
        </Title>
        <Address>{item.address}</Address>
        <Area>
          {item.buildingArea && item.buildingArea !== 0 && (
            <span>건물 {Number(item.buildingArea ?? 0).toFixed(1)}m²</span>
          )}
          <AreaDivider />
          <span>토지 {Number(item.landArea ?? 0).toFixed(1)}m²</span>
        </Area>
      </InfoContainer>
      <PriceContainer>
        <AppraisalPrice>
          감정가 <span>{ReportFormatNumber(item.appraisePrice)}</span>
        </AppraisalPrice>

        <MinPrice>
          최저가 <span>{ReportFormatNumber(item.minPrice)}</span>
          <PercentLabel>{item.rate}%</PercentLabel>
        </MinPrice>
      </PriceContainer>
      <Tags data={{ ...item, viewgray2: item.viewgray }} />

      {showLikeModal && (
        <AddInterestItemModal
          setShowLikeModal={setShowLikeModal}
          selectedIdx={item.iidx}
          mode="add"
          selectedItem={selectedItem}
          setActiveItem={setActiveItem}
          checkIsLikeItem={() => setIsLikeItem((prev) => !prev)}
        />
      )}
    </SlideCard>
  );
};

export default ImminentItem;

const SlideCard = styled.div`
  display: flex;
  min-width: 242px;
  width: 242px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const ImgContainer = styled.div`
  position: relative;
  width: 100%;
  height: 164px;
  align-self: stretch;

  & > img {
    border-radius: 12px;
    width: 100%;
    height: 100%;
  }
`;

const ImgTopTagSection = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
`;

const RecommendTag = styled.div`
  border-radius: 8px 0;
  border: 1px solid #f0528c;
  background: linear-gradient(296deg, #f0236e 14.22%, #ffae19 121.01%);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);

  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const TypeTag = styled.div<{ $hasRecommand?: boolean }>`
  display: inline-flex;
  height: 25px;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  border-radius: ${({ $hasRecommand }) =>
    $hasRecommand ? '0 0 8px 8px' : '8px 0'};
  background: rgba(55, 56, 60, 0.61);
  backdrop-filter: blur(4px);

  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const LikeIcon = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  width: 42px;
  height: 42px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12);

  & > img {
    width: 24px;
    height: 24px;
  }
`;

const ImgInfoBox = styled.div`
  position: absolute;
  bottom: 0;

  display: flex;
  width: 242px;
  padding: 4px 12px;
  align-items: center;
  gap: 6px;
  border-radius: 0 0 12px 12px;
  background: rgba(0, 0, 0, 0.48);

  color: #fff;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const ImgInfoDivider = styled.div`
  width: 1px;
  height: 8px;
  flex-shrink: 0;
  background: #e1e2e4;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const Title = styled.div`
  display: flex;
  gap: 2px;
  align-self: stretch;

  color: #222;
  font-size: 15px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.3px;

  span {
    color: #008aff;
  }
`;

const Address = styled.div`
  color: #222;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const Area = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  color: #6b7684;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const AreaDivider = styled.div`
  width: 1px;
  height: 10px;
  background: #e1e2e4;
`;

const PriceContainer = styled.div`
  display: flex;
  width: 242px;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;

  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const AppraisalPrice = styled.div`
  color: #616161;

  span {
    color: #222;
  }
`;

const MinPrice = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: #008aff;

  span {
    font-weight: 700;
  }
`;

const PercentLabel = styled.div`
  display: flex;
  padding: 1px 6px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: rgba(0, 138, 255, 0.06);

  color: #008aff;
  font-size: 12px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.24px;
`;
